import { useMutation } from "@tanstack/react-query";
import {
  NoteGenerationRequestNoteTypeEnum,
  TranscriptionControllerApi,
  TranscriptionSegmentRequest,
} from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

type Params = {
  segments?: Array<TranscriptionSegmentRequest>;
  noteType: NoteGenerationRequestNoteTypeEnum;
  /** Chart context reaches the prompt only when the patient is sent. */
  patientId?: string;
  appointmentId?: string;
  /** Provider's "Instructions to Scribe"; omitted when blank. */
  instructions?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useAiScriberAudioNoteGenerate = () =>
  useMutation({
    mutationFn: async ({
      segments,
      noteType,
      patientId,
      appointmentId,
      instructions,
    }: Params) =>
      new TranscriptionControllerApi(
        getConfigObject()
      ).generateNoteFromSegments(
        {
          segments: segments,
          noteType: noteType,
          patientId: patientId,
          appointmentId: appointmentId,
          instructions: instructions,
        },
        getXtenantId()
      ),
  });
